
import React from 'react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { Network } from 'lucide-react';

const InterfacesHeader = () => {
  return (
    <section className="pt-24 pb-12 md:pt-32 md:pb-16 bg-gradient-to-br from-blue-50 to-gray-100">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="order-2 lg:order-1">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6">
              Nahtlose <span className="text-blue-700">System&shy;integration</span> durch moderne Schnittstellen
            </h1>
            <p className="text-lg text-gray-600 mb-8">
              Verbinden Sie Ihre Geschäftssysteme effizient und sicher. Unsere maßgeschneiderten Schnittstellen-Lösungen 
              ermöglichen den nahtlosen Datenaustausch zwischen verschiedenen Anwendungen, Plattformen und Geschäftspartnern.
            </p>
            <div className="flex flex-wrap gap-4">
              <Button asChild size="lg" className="bg-blue-700 hover:bg-blue-800">
                <Link to="/about">Beratungstermin vereinbaren</Link>
              </Button>
              <Button asChild variant="outline" size="lg">
                <Link to="/references">Erfolgsbeispiele ansehen</Link>
              </Button>
            </div>
          </div>
          <div className="order-1 lg:order-2 flex justify-center lg:justify-end">
            <div className="relative">
              <div className="absolute inset-0 bg-blue-700 rounded-full blur-3xl opacity-20 transform -translate-x-4 translate-y-4"></div>
              <div className="relative bg-white p-6 shadow-xl rounded-xl border border-gray-100">
                <div className="grid grid-cols-2 gap-8 mb-8">
                  <div className="flex flex-col items-center p-4 bg-blue-50 rounded-lg">
                    <Network className="h-12 w-12 text-blue-700 mb-2" />
                    <span className="text-sm font-medium text-gray-800">API-Integration</span>
                  </div>
                  <div className="flex flex-col items-center p-4 bg-orange-50 rounded-lg">
                    <svg className="h-12 w-12 text-orange-500 mb-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 4V20M4 12H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <span className="text-sm font-medium text-gray-800">Daten&shy;austausch</span>
                  </div>
                  <div className="flex flex-col items-center p-4 bg-green-50 rounded-lg">
                    <svg className="h-12 w-12 text-green-600 mb-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <span className="text-sm font-medium text-gray-800">Automation</span>
                  </div>
                  <div className="flex flex-col items-center p-4 bg-purple-50 rounded-lg">
                    <svg className="h-12 w-12 text-purple-600 mb-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9 12H15M12 9V15M3 12C3 13.1819 3.23279 14.3522 3.68508 15.4442C4.13738 16.5361 4.80031 17.5282 5.63604 18.364C6.47177 19.1997 7.46392 19.8626 8.55585 20.3149C9.64778 20.7672 10.8181 21 12 21C13.1819 21 14.3522 20.7672 15.4442 20.3149C16.5361 19.8626 17.5282 19.1997 18.364 18.364C19.1997 17.5282 19.8626 16.5361 20.3149 15.4442C20.7672 14.3522 21 13.1819 21 12C21 9.61305 20.0518 7.32387 18.364 5.63604C16.6761 3.94821 14.3869 3 12 3C9.61305 3 7.32387 3.94821 5.63604 5.63604C3.94821 7.32387 3 9.61305 3 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <span className="text-sm font-medium text-gray-800">Erweiterbarkeit</span>
                  </div>
                </div>
                <div className="text-center p-3 bg-gray-50 rounded-lg">
                  <p className="text-sm text-gray-600">Wir verbinden Ihre Systeme für eine nahtlose Kommunikation und optimierte Geschäftsprozesse</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InterfacesHeader;
